import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#fda4af',
    },
    secondary: {
      main: '#fb7185',
    },
  },
  typography: {
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", Segoe UI Symbol, "Noto Color Emoji"',

     h1: {
       fontSize: '2.5rem',
       fontWeight: 700,
       color: '#0c0a09',
       marginTop: '2rem',
       marginBottom: '1.5rem',
     },
     h2: {
       fontSize: '1.9rem',
       fontWeight: 600,
       color: '#0c0a09',
       marginTop: '1.75rem',
       marginBottom: '1.25rem',
     },
     h3: {
       fontSize: '1.75rem',
       fontWeight: 700,
       color: '#0c0a09',
       marginTop: '1.25rem',
       marginBottom: '1.25rem',
     },
     h4: {
       fontSize: '1.5rem',
       fontWeight: 600,
       color: '#0c0a09',
       marginTop: '1.25rem',
       marginBottom: '1.25rem',
     },
     h5: {
       fontSize: '1.2rem',
       fontWeight: 500,
       color: '#0c0a09',
       marginTop: '1rem',
       marginBottom: '0.5rem',
     },
     h6: {
       fontSize: '1.1rem',
       fontWeight: 500,
       color: '#0c0a09',
       marginTop: '0.75rem',
       marginBottom: '0.5rem',
     },
    body1: {
      fontSize: '1rem',
      lineHeight: '2 !important',
       color: '#374151'
    },
    body2: {
      fontSize: '1rem',
      color: '#737373',
       lineHeight: '2 !important'
    },
    button: {
      fontWeight: 400,
      textTransform: 'none',
      padding: '0 8px',
      fontSize: '1rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          height: '40px',
          flex: '0 0 auto',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          borderRadius: '6px',
          border: 'none',
          padding: '0 8px',
          boxShadow: 'none !important',
          color: 'white'
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '20px',
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          '& > .MuiGrid-item': {
            paddingTop: '8px',
          },
        },
      },
    },
  }
});

export default theme;
